module.exports = __webpack_public_path__ + "img/align-vertical-center.6c6bdda1.svg";